export function footerMenuAccordion($) {
    const toggles = $('.footer-accordion-link');

    const initializeAccordion = () => {
        const isMobile = $(window).width() <= 768;

        toggles.each(function () {
            const toggle = $(this);
            const content = toggle.next('.footer-menu');

            if (isMobile) {
                // Mobile behavior
                if (!content.hasClass('initialized')) {
                    content.addClass('initialized'); // Prevent re-initialization
                    content.css({
                        display: content.hasClass('visible') ? 'block' : 'none',
                        height: content.hasClass('visible') ? content.prop('scrollHeight') + 'px' : '0',
                        opacity: content.hasClass('visible') ? '1' : '0',
                        overflow: 'hidden',
                    });

                    // Add click event for toggling
                    toggle.off('click').on('click', function () {
                        toggle.toggleClass('active');
                        const isVisible = content.hasClass('visible');

                        if (isVisible) {
                            // Collapse
                            content.css({ height: content.prop('scrollHeight') + 'px' });
                            setTimeout(() => {
                                content.css({ height: '0', opacity: '0' });
                            }, 10);

                            content.one('transitionend', function () {
                                content.css({ display: 'none' }).removeClass('visible');
                            });
                        } else {
                            // Expand
                            content.addClass('visible').css({ display: 'block' });
                            const fullHeight = content.prop('scrollHeight') + 'px';
                            content.css({ height: '0', opacity: '0' });

                            setTimeout(() => {
                                content.css({ height: fullHeight, opacity: '1' });
                            }, 10);
                        }
                    });
                }
            } else {
                // Desktop behavior
                toggle.removeClass('active');
                content.removeClass('visible initialized');
                content.css({ display: 'block', height: '', opacity: '', overflow: '' });
                toggle.off('click'); // Remove click event for desktop
            }
        });
    };

    // Initialize on load and resize
    initializeAccordion();
    $(window).on('resize', initializeAccordion);
}